<template>
<!-- add on features added by AMAR  -->
    <div>
        <vs-dropdown>
            <vs-button class="btn-drop" type="border" icon="more_vert"></vs-button>
            <vs-dropdown-menu>
                <vs-dropdown-item>
                <a @click="importTaskPopUp = true">Import task</a>
                </vs-dropdown-item>
                <vs-dropdown-item divider>
                <a @click="addTaskPopUp = true">Add task</a>
                </vs-dropdown-item>
                <vs-dropdown-item divider>
                <a @click="editTaskPopUp = true">Edit</a>
                </vs-dropdown-item>
                <vs-dropdown-item divider>
                <a @click="warningPopupShowForRemoveStatus = true">Delete</a>
                </vs-dropdown-item>
            </vs-dropdown-menu>
        </vs-dropdown>
        <!-- import task pop up -->
        <vs-popup fullscreen title="Import Task" :active.sync="importTaskPopUp">
            <vs-table
                    multiple
                    class="import-table"
                    v-model="selected"
                    :data="liveTaskImportData"
                  >
                    <template slot="thead">
                      <vs-th>Reference Id</vs-th>
                      <vs-th>Task Name</vs-th>
                      <vs-th>Task Details</vs-th>
                      <vs-th>Deadline</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                         <vs-td :data="data[indextr].reference_id">
                          {{ data[indextr].reference_id }}
                        </vs-td>
                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].details">
                          {{ data[indextr].details }}
                        </vs-td>

                        <vs-td :data="data[indextr].due_date">
                          {{ data[indextr].due_date }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <div class="flex flex-wrap justify-between items-center my-2">
                    <div class="my-2">
                      <vs-button type="border" v-if="meta.current_page>1" @click="loadMoreTask('minus')">Back</vs-button>
                    </div>
                    <div class="text-right my-2">
                      <vs-button v-if="meta.has_next" @click="loadMoreTask('plus')" class="mr-2">Load More</vs-button>
                      <vs-button @click="submitFromImport">Import</vs-button>
                    </div>
                  </div>
        </vs-popup>
        
        <!-- add task pop up -->
        <vs-popup fullscreen title="Add Task" :active.sync="addTaskPopUp">
           <ProjectCreate :project_id="project_id" :projectIdForAddTask="projectDetailsId" :fromWhere="'projectDetailsPage'" :selectedStatus="statusNameFromButton.name" @hideTheAddTaskModal="hideTheAddTaskModal($event)"/>
        </vs-popup>
        <!-- edit task pop up -->
        <vs-popup title="Edit Board Name" :active.sync="editTaskPopUp">
            <vs-input class="w-full" v-model="updatedStatusName" placeholder="Type and enter to add board name"  @keyup.native.enter="updateStatusName"/>
        </vs-popup>
        <vs-popup  title="Please Confirm" :active.sync="warningPopupShowForRemoveStatus">
        <vs-row>
          <span>Are you sure to delete this board?</span>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button @click="removeStatus" color="primary" type="filled" class="mr-2 vs-con-loading__container">Yes</vs-button>
          <vs-button @click="warningPopupShowForRemoveStatus=false" type="border">No</vs-button>
        </vs-row>
      </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {unassociatedList, projectUpdate} from '@/api/task-project.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ProjectCreate from '../project-create.vue'

export default {
  name: 'extra-action',
  props: ['projectDetailsId', 'statusNameFromButton'],
  components: {
    vSelect,
    flatPickr,
    ProjectCreate
  },
  data () {
    return {
      warningPopupShowForRemoveStatus: false,
      project_id: '',
      importTaskPopUp: false,
      addTaskPopUp: false,
      editTaskPopUp: false,
      selected:[],
      liveTaskImportData: [],
      query_page: {
        page: 1,
        limit: 10
      },
      meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      updatedStatusName: '',
      projectData: {
        attachLiveTask: []
      }
    }
  },
  watch: {
    importTaskPopUp () {
      if (this.importTaskPopUp === true) {
        this.liveTaskImportData = this.$store.getters.getGlobalImportedList
        this.meta = this.$store.getters.getImportedMeta
      } 
    }
  },
  mounted () {
    this.updatedStatusName = this.statusNameFromButton.name
  },
  methods: { 
    async loadMoreTask (showType) {
      if (showType === 'plus') {
        this.meta.current_page = this.meta.current_page + 1
      } else {
        this.meta.current_page = this.meta.current_page - 1
      }
      this.fetchLiveTask(this.meta.current_page)
    },
    fetchLiveTask (query) {
      unassociatedList(localStorage.getItem('customer_id'), query)
        .then((res) => {
          this.meta = res.data.data.meta
          
          this.liveTaskImportData = res.data.data.tasks
        })
        .catch((e) => {
          
        })
    },  
    updateStatusName () {
      if (this.updatedStatusName !== '') {
        const payload = {
          id: this.statusNameFromButton.id,
          name: this.updatedStatusName
        }
        this.$emit('updateStatusName', payload)
        this.editTaskPopUp = false
      }
    },
    removeStatus () {
      if (this.statusNameFromButton.tasks.length === 0) {
        this.$emit('removeStatus', this.statusNameFromButton)
      } else {
        this.warningPopupMessage('You can\'t delete this status')
      }
    },
    hideTheAddTaskModal (data) {
      this.addTaskPopUp = false
      this.updateKanbanBoard(data)
    },
    updateKanbanBoard (data) {
      this.$emit('updateKanbanBoard', data)
    },
    submitFromImport () {
      for (let index = 0; index < this.selected.length; index++) {
        this.projectData.attachLiveTask.push({
          id: this.selected[index].id,
          project_status_name: this.statusNameFromButton.name
        })
      }
      const payload = {
        updateField: this.projectData  
      }
      this.updateProj(payload)
    },
    updateProj (data) {       
      projectUpdate(localStorage.getItem('customer_id'), this.projectDetailsId, data)
        .then((res) => {
          this.updateKanbanBoard(this.selected)
          this.successPopupMessage('Project Updated Successfully')
          this.importTaskPopUp = false
          this.projectData.attachLiveTask = []
        })
        .catch((e) => {
          this.projectData.attachLiveTask = []
          this.importTaskPopUp = false
          this.warningPopupMessage('Something Went Wrong')
        })
    },
    successPopupMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    warningPopupMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    }
  }
}
</script>